// extracted by mini-css-extract-plugin
module.exports = {"container":"ReviewForm_container__1Sw8h","title":"ReviewForm_title__1Vt52","content":"ReviewForm_content__3-S3E"};